import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Box } from '@uhg-abyss/web/ui/Box';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Text } from '@uhg-abyss/web/ui/Text';

export const ModalTitle = styled(Heading, {
  '&.abyss-heading-root': {
    fontFamily: 'UHCSerif,Georgia Bold,serif',
    fontWeight: '$semibold',
    fontSize: '1.802rem',
    lineHeight: '2.25rem',
  },
  dynamic: ({ textAlign }) => {
    return {
      textAlign,
    };
  },
});

export const PaddedTitleBox = styled(Box, {
  '&.abyss-box-root': {
    padding: '50px 0px 20px',
  },
});

export const PaddedText = styled(Text, {
  '&.abyss-text-root': {
    lineHeight: '24px',
    padding: '0px 10px',
  },
});

export const PaddedBodyBox = styled(Box, {
  '&.abyss-box-root': {
    padding: '0px 16px',
  },
});

export const BodyContainer = styled('div', {
  padding: '0 100px',
  dynamic: ({ textalign }) => {
    return { textalign };
  },
});
export const StyledLayout = styled(Layout.Stack, {
  marginBottom: '4% !important',
});
